<template>
  <div
    class="trends Tends-Horizontal mb-6"
    data-epica-module-name="Tendencias"
    v-if="posts"
    data-mrf-recirculation="Tendencias"
  >
    <h3 class="heading-title mb-3">TENDENCIAS</h3>
    <div class="double-line"></div>
    <div class="row mt-5 row-cols-3">
      <div v-for="(post, idx) in posts" :key="post.id" class="col newsTends">
        <div class="d-flex">
          <div class="numberTends mr-3" v-html="idx + 1"></div>
          <div>
            <div class="V_Title">
              <a
                :href="post.url"
                class="kicker"
                :class="post.className"
                v-html="post.header"
              ></a>
              <h2 class="tt">
                <a
                  :href="post.url"
                  v-html="post.title"
                  :class="post.className"
                ></a>
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
export default {
  watch: {
    posts: function () {
      Vue.nextTick(() => {
        document.dispatchEvent(lrLoad);
      });
    },
  },
  props: {
    groupName: String,
  },
  computed: {
    ...mapGetters("master", {
      posts: "trends",
    }),
  },
};
</script>
